import { render, staticRenderFns } from "./childList.vue?vue&type=template&id=f39b8fa0&scoped=true"
import script from "./childList.vue?vue&type=script&lang=js"
export * from "./childList.vue?vue&type=script&lang=js"
import style0 from "./childList.vue?vue&type=style&index=0&id=f39b8fa0&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39b8fa0",
  null
  
)

export default component.exports